<template>
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex md3 lg2>
          <v-text-field v-model="query.orderNum" label="订单号" class="pr-2" v-on:keyup.enter="getList()"></v-text-field>
        </v-flex>
  
  
        <v-flex md3 lg2>
          <div>
            <v-select v-model="query.pageSize" :items="pageSizes" item-text="label" @change="getList()" item-value="value"
              label="每页条数" class="pr-2 inline-block" required></v-select>
          </div>
        </v-flex>
  
        <v-flex xs-12 md-12 lg-12 sm-12>
          <v-btn color="gray" @click="resetSearch()">重置</v-btn>
          <v-btn color="dark" @click="getList()">
            <v-icon size="14">mdi-account-search</v-icon>&nbsp;搜索
          </v-btn>
        </v-flex>
  
      </v-layout>
  
      <v-divider></v-divider>
  
      <v-layout wrap justify-space-between>
  
  
      </v-layout>
  
      <v-layout row wrap>
        <v-flex xs-12 md-12 lg-12 sm-12>
          <el-table ref="multipleTable" :data="items" tooltip-effect="dark" style="width: 100%" border v-loading="tableLoad"
            @selection-change="handleSelectionChange">
           
            <el-table-column label="订单号" prop="order.orderNum"></el-table-column>
            <el-table-column label="总金额" >
                <template slot-scope="scope">
                <div>￥{{ Number(scope.row.order.totalPrice).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="配送费" >
                <template slot-scope="scope">
                <div>￥{{ Number(scope.row.order.pei).toFixed(2) }}</div>
              </template>
            </el-table-column>
           
  
            <el-table-column label="商家收益">
              <template slot-scope="scope">
                <div>￥{{ Number(scope.row.get.sh).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="代理收益">
              <template slot-scope="scope">
                <div>￥{{ Number(scope.row.get.dl).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="平台收益">
              <template slot-scope="scope">
                <div>￥{{ Number(scope.row.get.pt).toFixed(2) }}</div>
              </template>
            </el-table-column>

           
            <el-table-column label="入账时间" prop="_createTime"></el-table-column>
            
           
           
           
          </el-table>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-end mt-3>
        <el-pagination @current-change="handleCurrentChange" :current-page="query.currentPage" :page-size="query.pageSize"
          layout="total,  prev, pager, next, jumper" :total="total"></el-pagination>
      </v-layout>
     
    </v-container>
  </template>
  <script>
  // import detail from './OrderDetail'
  // import Authority from './Authority'
  let _this;
  export default {
  
  
    props: {
      load: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      load(val) {
        if (val) {
          this.pageLoad = val
        }
      },
      pageLoad(val) {
        if (val) {
          this.getList();
        }
      }
    },
    data() {
      return {
        pageLoad: false,
  
        items: [],
        query: {
          orderNum: '',
          currentPage: 1,
          pageSize: 10
        },
        multipleSelection: [],
        pageSizes: this.$pageSizes,
        tableLoad: false,
        total: 0,
      };
    },
    mounted() {
      _this = this;
      this.getList();
    },
    methods: {
      //获取列表
      async getList() {
        this.tableLoad = true;
        const res = await this.$post('admin/getHistoryList', this.query)
        _this.tableLoad = false;
        if (res.errno === 0) {
          for (let i in res.data.data) {
            if(res.data.data[i]._createTime){
              res.data.data[i]._createTime = this.$time(res.data.data[i]._createTime)
            }else{
              res.data.data[i]._createTime = '未记录'
            }
           
          }
          _this.items = res.data.data;
          _this.total = res.data.count;
        }
  
      },
      async confirmOrder(e) {
  
        this.$confirm(`订单号${e.orderNum},是否完成当前订单?`).then(async r => {
          if (r == 'confirm') {
  
          }
        })
  
      },
      //重置搜索
      resetSearch() {
        this.query.orderNum = '';
        this.query.status = '';
        this.getList();
      },
  
      //选中
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
  
      //获取id
      getIds() {
        let arr = [];
        for (let i in this.multipleSelection) {
          arr.push(this.multipleSelection[i].id)
        }
        return arr
      },
  
      //跳转页码
      handleCurrentChange(val) {
        this.query.currentPage = val;
        this.getList();
      },
  
     
      //更新值
      changeMsg(e) {
        this.getList()
      }
  
    }
  };
  </script>
    